var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { createRoot } from 'react-dom/client';
import { createIwa } from '@cognitranlimited/itis-web';
import { getProps } from './props';
import './styles.scss';
var Iwa = createIwa();
var container = document.getElementById('root');
var root = container && createRoot(container);
root === null || root === void 0 ? void 0 : root.render(React.createElement(Iwa, __assign({}, getProps())));
